import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import urls from '../../routing/urls';
import * as companyProfileService from '../../services/companyProfileService';
import companyProfileActionConstants from '../constants/companyProfileActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const getCompanyProfile = (id, navigate) => async (dispatch) => {
  dispatch({ type: companyProfileActionConstants.GET_COMPANY_PROFILE });

  try {
    const response = await companyProfileService.getCompanyProfile(id);
    if (response.data.response_code === responseCodes.OK) {
      dispatch({
        type: companyProfileActionConstants.GET_COMPANY_PROFILE_SUCCESS,
        payload: response.data.payload.organization,
      });
    } else {
      dispatch({
        type: companyProfileActionConstants.GET_COMPANY_PROFILE_ERROR,
        payload: response.data.error,
      });
      Notification.error(response.data.error);
    }
  } catch (error) {
    dispatch({
      type: companyProfileActionConstants.GET_COMPANY_PROFILE_ERROR,
      payload: error.message,
    });
    Notification.error(t('notifications.organizationNotFound'));
    navigate(urls.profile);
  }
};
